module.exports = __webpack_public_path__ + "static/media/IMG_2089y.15cdebec.jpg";